import { Button } from '@peacecover/component';

interface BottomCTAProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  /** 예: 데스크톱에서 `mx-auto max-w-[var(--chakra-sizes-xl)]` */
  className?: string;
}

const BottomCTA = ({ onClick, disabled, children, className = '' }: BottomCTAProps) => {
  return (
    <div
      className={`fixed bottom-0 left-0 right-0 bg-background-light dark:bg-background-dark px-[24px] pt-[12px] ${className}`}
      style={{
        paddingBottom: 'calc(10px + env(safe-area-inset-bottom))'
      }}
    >
      <Button
        onClick={onClick}
        size="large"
        disabled={disabled}
        className="w-full text-[17px] font-semibold leading-none"
      >
        {children}
      </Button>
    </div>
  );
};

export default BottomCTA;
